<template>
  <div class="cart-page">
   <NavBar />
    <h1>Shopping Cart</h1>

    <div v-if="cart.length === 0" class="empty-cart">
      <p>Your cart is empty.</p>
    </div>

    <div v-else>

      <!-- Cart headings -->
      <div class="cart-header">
        <div>Product</div>
        <div>Price</div>
        <div>Quantity</div>
        <div>Total</div>
      </div>

      <!-- Products -->
      <div
        v-for="(product, index) in cart"
        :key="index"
        class="cart-row"
      >

        <!-- Product -->
        <div class="product-column">
          <img
            v-if="product.image"
            :src="product.image"
            :alt="product.name"
            class="cart-image"
          >

          <div>
            <h3>{{ product.name }}</h3>
            <p>{{ product.color }}</p>

            <button @click="removeFromCart(index)"
            class="remove-btn">
              Remove
            </button>
          </div>
        </div>

        <!-- Price -->
        <div>
          ₦{{ product.price }}
        </div>

        <!-- Quantity -->
        <div class="quantity">
          <button @click="decreaseQuantity(index)">
            −
          </button>

          <span>{{ product.quantity }}</span>

          <button @click="increaseQuantity(index)">
            +
          </button>
        </div>

        <!-- Product Total -->
        <div>
          ₦{{ product.price * product.quantity }}
        </div>

      </div>

      <!-- Cart Summary -->
      <div class="cart-summary">

        <h2>
          Subtotal: ₦{{ total }}
        </h2>

        <router-link to="/checkout" class="checkout-button">
          Checkout
        </router-link>

      </div>

    </div>

  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'

export default {
  components: {
    NavBar
  },
  data() {
    return {
      cart: []
    }
  },

  computed: {
    total() {
      return this.cart.reduce((sum, product) => {
        return sum + (product.price * product.quantity)
      }, 0)
    }
  },

 mounted() {
  this.cart = JSON.parse(localStorage.getItem('cart')) || []

  this.cart.forEach(product => {
    if (!product.quantity) {
      this.$set(product, 'quantity', 1)
    }
  })
},

  methods: {

    increaseQuantity(index) {
      this.cart[index].quantity++

      localStorage.setItem(
        'cart',
        JSON.stringify(this.cart)
      )
    },

    decreaseQuantity(index) {
      if (this.cart[index].quantity > 1) {
        this.cart[index].quantity--

        localStorage.setItem(
          'cart',
          JSON.stringify(this.cart)
        )
      }
    },

    removeFromCart(index) {
      this.cart.splice(index, 1)

      localStorage.setItem(
        'cart',
        JSON.stringify(this.cart)
      )
    }
  }
}
</script>

<style scoped>

.cart-page {
  min-height: 100vh;
  padding: 50px 7%;
  background: #f3e5dc;
  color: #333;
}


/* PAGE TITLE */

.cart-page h1 {
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  font-size: 34px;
}


/* CART AREA */

.cart-section {
  background: #fffaf7;
  border: 1px solid #d9b5a4;
  border-radius: 10px;
  overflow: hidden;
}


/* CART HEADER */

.cart-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  padding: 18px 25px;
  background: #c76b4a;
  color: white;
  font-weight: bold;
}


/* CART ROW */

.cart-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  align-items: center;
  padding: 25px;
  border-bottom: 1px solid #e2c9bd;
}


/* PRODUCT */

.product-column {
  display: flex;
  align-items: center;
  gap: 20px;
}

.cart-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  background: #ead4c8;
}

.product-details h3 {
  margin: 0 0 8px;
  color: #333;
}

.product-details p {
  margin: 0 0 10px;
  color: #a85c40;
  font-size: 14px;
}


/* REMOVE */

.remove-btn {
  font-size: 13px;  
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #a85c40;
  cursor: pointer;
  padding: 0;
  transition: 0.2s;

}

.remove-btn:hover {
  color: #333;
  background: white;
}


/* PRICE */

.price,
.item-total {
  font-weight: 600;
  color: #333;
}


/* QUANTITY */

.quantity {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quantity button {
  width: 32px;
  height: 32px;
  border: 1px solid #c76b4a;
  background: #f3e5dc;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
}

.quantity button:hover {
  background: #c76b4a;
  color: white;
}

.quantity span {
  min-width: 20px;
  text-align: center;
  font-weight: bold;
}


/* SUMMARY */

.cart-summary {
  margin-top: 30px;
  padding: 25px 30px;
  background: #333;
  color: white;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-summary h2 {
  margin: 0;
  font-size: 22px;
}


/* CHECKOUT BUTTON */

.checkout-button {
  padding: 13px 30px;
  border: none;
  background: #c76b4a;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 15px;
  display: inline-block;
  text-decoration: none;
  text-align: center;
}

.checkout-button:hover {
  background: #e08a68;
}


/* EMPTY CART */

.empty-cart {
  text-align: center;
  padding: 70px 20px;
  background: #fffaf7;
  border: 1px solid #d9b5a4;
  border-radius: 10px;
}

.empty-cart h2 {
  color: #333;
}

.empty-cart p {
  color: #a85c40;
}


/* MOBILE */

@media (max-width: 768px) {

  .cart-page {
    padding: 30px 20px;
  }

  .cart-header {
    display: none;
  }

  .cart-row {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .cart-summary {
    flex-direction: column;
    gap: 20px;
    align-items: stretch;
    text-align: center;
  }

  .checkout-button {
    width: 100%;
  }

}

</style>